import { EmptyIcon } from "src/sections/assets/icons/icons";

// Пустое состояние блока отзывов. Цвета — только из палитры kj:
// раньше здесь стояли text-neutral-900 / text-neutral-500 из светлой темы
// шаблона, и на тёмно-сливовом фоне (#3C2027) этот текст практически
// сливался с фоном — «нет отзывов» было не прочитать.
export default function Empty({ text, subText }) {
  return (
    <div className="mt-16 lg:mt-0 lg:col-start-6 lg:col-span-7 w-full text-center h-full">
      <div className="flex justify-center items-center h-full">
        <div>
          <EmptyIcon className="mx-auto h-12 w-12 text-kj-line" />
          <h3 className="mt-2 font-medium text-kj-ink">{text}</h3>
          <p className="mt-1 text-sm text-kj-sub">{subText}</p>
        </div>
      </div>
    </div>
  );
}
